import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';
import { useState } from 'react';

const Navigation = () => {
  const [isActive, setIsActive] = useState(false);

  const toggleMenu = () => {
    setIsActive(!isActive);
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">Mynexo</Link>

        <div 
          className={`menu-toggle ${isActive ? 'active' : ''}`} 
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={`nav-menu ${isActive ? 'active' : ''}`}>
          <Link to={ROUTES.LOGIN} className="btn-outline" onClick={() => setIsActive(false)}>
            Sign In
          </Link>
          <Link to={ROUTES.REGISTER} className="btn-primary" onClick={() => setIsActive(false)}>
            Create Account
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navigation;